// extracted by mini-css-extract-plugin
export default {"Outer":"Snackbar_Outer__bvGpt","Visible":"Snackbar_Visible__omWTQ","InItemDetails":"Snackbar_InItemDetails__nCpFk","Info":"Snackbar_Info__n5kM6","Success":"Snackbar_Success__ORdfN"};